import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_activity_f_fasting_paywall~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_activity_f_fasting_paywall/walking-f'),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_activity_f_fasting_paywall~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_activity_f_fasting_paywall/tai-chi-walking-f-v2'),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_activity_f_fasting_paywall~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_activity_f_fasting_paywall/tai-chi-walking-f-pr'),
			},
		},
	},
]

export default config
